import { Flow_0_0_2 } from '@flexus/core';

export const BUI_103: Flow_0_0_2 = {
	id: '103',
	name: 'la_job_done',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
